import { Wallet } from '@/hooks/useWallet';
import { Card } from '@/components/ui/card';
import { DollarSign, TrendingUp, Clock } from 'lucide-react';

interface WalletHeaderProps {
  wallet: Wallet | null;
  loading: boolean;
}

export const WalletHeader = ({ wallet, loading }: WalletHeaderProps) => {
  if (loading) {
    return (
      <Card className="p-8 mb-6">
        <div className="animate-pulse space-y-4">
          <div className="h-4 w-32 bg-muted rounded"></div>
          <div className="h-12 w-48 bg-muted rounded"></div>
        </div>
      </Card>
    );
  }

  const totalBalance = (wallet?.balance || 0) + (wallet?.pending_balance || 0);

  return (
    <Card className="p-8 mb-6 bg-gradient-to-br from-primary/10 to-primary/5">
      <div className="space-y-6">
        <div>
          <h2 className="text-sm font-medium text-muted-foreground mb-2">Total Balance</h2>
          <div className="flex items-baseline gap-2">
            <span className="text-5xl font-bold">${totalBalance.toFixed(2)}</span>
            <span className="text-xl text-muted-foreground">{wallet?.currency || 'USD'}</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex items-center gap-3 p-4 rounded-lg bg-background/50">
            <div className="p-2 rounded-full bg-green-500/10">
              <DollarSign className="w-5 h-5 text-green-600" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">Available</p>
              <p className="text-lg font-semibold">${(wallet?.balance || 0).toFixed(2)}</p>
            </div>
          </div>

          <div className="flex items-center gap-3 p-4 rounded-lg bg-background/50">
            <div className="p-2 rounded-full bg-blue-500/10">
              <Clock className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">Pending</p>
              <p className="text-lg font-semibold">${(wallet?.pending_balance || 0).toFixed(2)}</p>
            </div>
          </div>

          <div className="flex items-center gap-3 p-4 rounded-lg bg-background/50">
            <div className="p-2 rounded-full bg-orange-500/10">
              <TrendingUp className="w-5 h-5 text-orange-600" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">In Escrow</p>
              <p className="text-lg font-semibold">${(wallet?.escrow_balance || 0).toFixed(2)}</p>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};